import { z } from "zod";

import getEnv from "@/env";

export const zodEnv = z.object({
  VITE_HOSTNAME: z.string().optional(),
  VITE_RBAC_TOKEN_API_CLIENT_ID: z.string().optional(),
  VITE_RBAC_TOKEN_API_CLIENT_SECRET: z.string().optional(),
});

const hostname = window.location.hostname;

const env = getEnv(hostname);

export const APP_URL = env.APP_URL;
export const API_URL = env.API_URL;
export const MSAL_TENANT_ID = env.MSAL_TENANT_ID;
export const MSAL_CLIENT_ID = env.MSAL_CLIENT_ID;
export const MSAL_REDIRECT_URI = env.MSAL_REDIRECT_URI;
export const MSAL_POST_LOGOUT_REDIRECT_URI = env.MSAL_POST_LOGOUT_REDIRECT_URI;
export const USE_KONG_API = env.USE_KONG_API;
export const TOKEN_API_URL = env.TOKEN_API_URL;

export const TOKEN_API_CLIENT_ID = env.TOKEN_API_CLIENT_ID || import.meta.env.VITE_RBAC_TOKEN_API_CLIENT_ID;
export const TOKEN_API_CLIENT_SECRET = env.TOKEN_API_CLIENT_SECRET || import.meta.env.VITE_RBAC_TOKEN_API_CLIENT_SECRET;
